import React from 'react'
import { useHasMounted } from '../util/hooks'

// https://blog.logrocket.com/fixing-gatsbys-rehydration-issue/
// https://www.joshwcomeau.com/react/the-perils-of-rehydration/
const ClientOnly = ({ children, ...props }) => {
  const hasMounted = useHasMounted()

  if (!hasMounted) {
    return null
  }

  return (
    <div {...props}>
      {children}
    </div>
  )
}

export default ClientOnly
